import React from 'react'
import MillUnitsList from './MillUnitsList'
import { useState } from 'react'
import PeopleModal from './PeopleModal'

export default function People() {
        const [selectedUnit, setSelectedUnit] = useState(null)
        const [editing, setEditing] = useState(null)
        const [shouldUpdate, setShouldUpdate] = useState(false)
    
  return (
    <>
      <MillUnitsList selectedUnit={selectedUnit} setSelectedUnit={setSelectedUnit} editing={editing} setEditing={setEditing} shouldUpdate={shouldUpdate} />
      {selectedUnit && <PeopleModal selectedUnit={selectedUnit} setSelectedUnit={setSelectedUnit} editing={editing} setEditing={setEditing} setShouldUpdate={setShouldUpdate} />}
    </>
  )
}
